import { request } from '../browser/request';
import { ds24cart_id } from './ds24cart_id';
import { ds24cart_jsonp_args } from './ds24cart_jsonp_args';
import { ds24cart_maybe_show_msg } from './ds24cart_maybe_show_msg';
import { ds24cart_wait_start, ds24cart_wait_stop } from './ds24cart_wait';
import { ds24_checkout_url } from '../common/ds24_checkout_url';

export function ds24cart_checkout_exec()
{
    if (window.DS24_OF_AS_POPUP) {

        const url = ds24_checkout_url() + '/checkout/' + ds24cart_id();

        window.open(url);
        return;
    }

~
    ds24cart_wait_start();

    const url = ds24_checkout_url() + '/cart/checkout/?' + ds24cart_jsonp_args();

    request({
        url,
        dataType: 'jsonp',
        success: ds24cart_callback_checkout
    });
}

export function ds24cart_callback_checkout( result: any )
{
    ds24cart_wait_stop();
    ds24cart_maybe_show_msg( result );

    if (result.target_url) {

        location.href=result.target_url;


    }
}
